import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timeAgo',
    standalone: false
})
export class TimeAgoPipe implements PipeTransform {
  transform(epochTime: number): string {
    if (!epochTime) {
      return '-';
    }

    const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
    const difference = currentTime - epochTime; // Difference in seconds

    switch (true) {
      case difference < 0:
        return `In the future`;

      case difference < 60:
        return `${difference} sec ago`;

      case difference < 3600:
        const minutes = Math.floor(difference / 60);
        return `${minutes} min ago`;

      case difference < 86400:
        const hours = Math.floor(difference / 3600);
        return `${hours} hr ago`;

      default:
        const days = Math.floor(difference / 86400);
        return `${days} days ago`;
    }
  }
}
